import {
  Card,
  CardContent,
  Grid,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSPhone from "../../Components/Phone/WSPhone";
import WSDateField from "../../Components/DateField/WSDateField";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
import WSFileUpload from "../../Components/FileUpload/WSFileUpload";
import WSButton from "../../Components/Button/WSButton";

export const SaleInvoice: React.FC<any> = React.memo((props) => {
  const [isProduct, setIsProduct] = useState(false);
  const { control, register, handleSubmit, setValue, reset } = useForm<any>();
  const navigate = useNavigate();
  const { fields, append, remove, replace } = useFieldArray({
      name: "items",
      control,
    });
  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsProduct(event.target.checked);
  };

  const handleData = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };


  const handleClose = () => {
    navigate("/");
  };

  return (
    <form>
      <Card>
        <CardContent>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            wrap="nowrap"
          >
            <Grid item>
              <Grid container spacing={2} alignItems="center" wrap="nowrap">
                <Grid item>
                  <Typography fontWeight="bold" variant="h6">
                    Sale
                  </Typography>
                </Grid>

                <Grid item>
                  <Typography
                    variant="body2"
                    sx={{
                      color: !isProduct ? "primary.main" : "text.secondary",
                      fontWeight: !isProduct ? "bold" : "normal",
                    }}
                  >
                    Credit
                  </Typography>
                </Grid>

                <Grid item>
                  <Switch
                    checked={isProduct}
                    onChange={handleToggle}
                    color="primary"
                    size="small"
                  />
                </Grid>

                <Grid item>
                  <Typography
                    variant="body2"
                    sx={{
                      color: isProduct ? "primary.main" : "text.secondary",
                      fontWeight: isProduct ? "bold" : "normal",
                    }}
                  >
                    Cash
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            {/* Right side: Close Icon */}
            <Grid item>
              <IconButton onClick={handleClose}>
                <WSIcons.CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={3}>
            <Grid item xs={12} sm={6}>
  {!isProduct ? (
    // Credit: Show Customer
    <WSTextField
      label={"Customer"}
      {...register("customer")}
      id="customer"
      name="customer"
      control={control}
      rules={{ required: false }}
    />
  ) : (
    // Cash: Show Billing Name + Address
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <WSTextField
          label={"Billing Name"}
          {...register("billingName")}
          id="billingName"
          name="billingName"
          control={control}
          rules={{ required: true }}
        />
      </Grid>
      <Grid item xs={12}>
        <WSTextAreaField
          label={"Address"}
          {...register("address")}
          id="address"
          name="address"
          control={control}
          rows={3}
          rules={{ required: true }}
        />
      </Grid>
    </Grid>
  )}
</Grid>

            <Grid item xs={12} sm={6}>
              <WSPhone
                label={"Phone No"}
                id={"phoneNumber"}
                name={"phoneNumber"}
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Invoice No"}
                {...register("invoiceNo")}
                id="invoiceNo"
                name="invoiceNo"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSDateField
                id="invoiceDate"
                name="invoiceDate"
                label={"Invoice Date "}
                dateFormat="DD-MM-YYYY"
                denyFuturOrPast="custom"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSSelectField
                rules={{ required: true }}
                control={control}
                id="stateOfSupply"
                {...register("stateOfSupply")}
                name="stateOfSupply"
                label="State Of Supply"
              />
            </Grid>
                {fields.map((row, index) => (
              <Grid
                container
                spacing={2}
                key={row.id}
                alignItems="center"
                mt={1}
                ml={1}
              >
                     <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="Category"
                    {...register(`items.${index}.category`)}
                    id={`category-${index}`}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="Item"
                    {...register(`items.${index}.item`)}
                    id={`item-${index}`}
                    control={control}
                  />
                </Grid>
     <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="Item Code"
                    {...register(`items.${index}.itemCode`)}
                    id={`itemCode-${index}`}
                    control={control}
                  />
                </Grid>
                 <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="HSN Code"
                    {...register(`items.${index}.hsnCode`)}
                    id={`hsnCode-${index}`}
                    control={control}
                  />
                </Grid>
                   <Grid item xs={12} sm={2}>
                  <WSTextField
                    label="Description"
                    id={`description-${index}`}
                    {...register(`items.${index}.description`, {})}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="QTY"
                    id={`qty-${index}`}
                    {...register(`items.${index}.qty`, {})}
                    control={control}
                  />
                </Grid>
  <Grid item xs={12} sm={1}>
                  <WSSelectField
                    label="Unit"
                    rules={{ required: true }}
                    {...register(`items.${index}.unit`)}
                    id={`unit-${index}`}
                    control={control}                  />
                </Grid>
                <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="Price/Unit"
                    id={`price-${index}`}
                    {...register(`items.${index}.price`, {})}
                    control={control}
                  />
                </Grid>
<Grid item xs={12} sm={1}>
                  <WSTextField
                    label="Discount"
                    id={`discount-${index}`}
                    {...register(`items.${index}.discount`, {})}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="Tax"
                    id={`tax-${index}`}
                    {...register(`items.${index}.tax`, {})}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} sm={1}>
                  <WSTextField
                    label="Amount"
                    id={`amount-${index}`}
                    {...register(`items.${index}.amount`, {})}
                    control={control}
                    
                  />
                </Grid>
                <Grid item display="flex" justifyContent="center">
                  <WSIcons.DeleteIcon
                    onClick={() => {
                      remove(index);
                    }}
                    sx={{ color: "red", cursor: "pointer" }}
                  />
                </Grid>
              </Grid>
            ))}

            <Grid item xs={12} sx={{ marginLeft: 1 }}>
              <WSButton
                id="addButton"
                label="+ Add"
                size="small"
                onClick={() =>
                  append({
                    productId: "",
                    quantity: "",
                    unit: "",
                    unitPrice: "",
                    total: "",
                  })
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextAreaField
                label={"Description"}
                id={"description"}
                name={"description"}
                control={control}
                rules={{ required: false }}
                rows={3}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <WSTextField
                label={"Total"}
                {...register("total")}
                id="total"
                name="total"
                control={control}
                rules={{ required: false }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
            <WSImageUpload
              control={control}
              id="image"
              name="image"
              label="Add image"
              rules={{ required: false }}
            />
            </Grid>
            <Grid item xs={12} sm={6}>
                    <WSFileUpload
                  name="addDocument"
                  label="Add Document"
                  control={control}
                  rules={{ required: false }}
                  acceptFileTypes=".jpg,.jpeg,.png"
                  maxFileSizeMB={2}
                  //  defaultValue={defaultImg}
                  id={"addDocument"}
                  image={true}
                  align="Start"
                  isToolTipImg={false}
                  multiple={true}
                />
            </Grid>
          </Grid>
             
        </CardContent>
      </Card>
       <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
                    <Grid item>
                      <WSButton
                        id="share"
                        label="Share"
                        size="medium"
                        variant="outlined"
                        color="primary"
                        
                        sx={{
                          borderRadius: 2,
                          border: "1px solid rgba(126, 176, 246, 1)",
                          color: "rgba(126, 176, 246, 1)",
                          backgroundColor: "#FFFFFF",
                        }}
                      />
                    </Grid>
          
                    <Grid item>
                      <WSButton
                        id="submit"
                        type="submit"
                        label="Save"
                        size="medium"
                        variant="outlined"
                        color="primary"
                        onClick={handleSubmit(handleData)}
                        sx={{
                          borderRadius: 2,
                          width: "6rem",
                          border: "1px solid rgba(126, 176, 246, 1)",
                          color: "#FFFFFF",
                          backgroundColor: "rgba(126, 176, 246, 1)",
                          "&:hover": {
                            backgroundColor: "rgba(126, 176, 246, 1)",
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
    </form>
  );
});
